import { withInstall } from '@zoryn/utils'
import DataSource from './src/data-source.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZDataSource: SFCWithInstall<typeof DataSource> =
  withInstall(DataSource)

export default ZDataSource
export * from './src/types'
export * from './src/constants'
export * from './src/data-source-component'
export * from './src/data-source-api'
export * from './src/data-source-grid'
export * from './src/parse-sql-fields'
